module.exports = __webpack_public_path__ + "static/media/luckyBagTypeImg.8aef2970.png";